// source: pbtypes/gen/flight_connect/client_skybus_stats.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.flight_connect.ClientSkybusStats', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_connect.ClientSkybusStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_connect.ClientSkybusStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_connect.ClientSkybusStats.displayName = 'proto.flight_connect.ClientSkybusStats';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_connect.ClientSkybusStats.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_connect.ClientSkybusStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_connect.ClientSkybusStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.ClientSkybusStats.toObject = function(includeInstance, msg) {
  var f, obj = {
rxMessageCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
txMessageCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
videoFrameCount: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_connect.ClientSkybusStats}
 */
proto.flight_connect.ClientSkybusStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_connect.ClientSkybusStats;
  return proto.flight_connect.ClientSkybusStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_connect.ClientSkybusStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_connect.ClientSkybusStats}
 */
proto.flight_connect.ClientSkybusStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setRxMessageCount(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setTxMessageCount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setVideoFrameCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_connect.ClientSkybusStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_connect.ClientSkybusStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_connect.ClientSkybusStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.ClientSkybusStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRxMessageCount();
  if (f !== 0) {
    writer.writeSint32(
      1,
      f
    );
  }
  f = message.getTxMessageCount();
  if (f !== 0) {
    writer.writeSint32(
      2,
      f
    );
  }
  f = message.getVideoFrameCount();
  if (f !== 0) {
    writer.writeSint32(
      3,
      f
    );
  }
};


/**
 * optional sint32 rx_message_count = 1;
 * @return {number}
 */
proto.flight_connect.ClientSkybusStats.prototype.getRxMessageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.ClientSkybusStats} returns this
 */
proto.flight_connect.ClientSkybusStats.prototype.setRxMessageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional sint32 tx_message_count = 2;
 * @return {number}
 */
proto.flight_connect.ClientSkybusStats.prototype.getTxMessageCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.ClientSkybusStats} returns this
 */
proto.flight_connect.ClientSkybusStats.prototype.setTxMessageCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional sint32 video_frame_count = 3;
 * @return {number}
 */
proto.flight_connect.ClientSkybusStats.prototype.getVideoFrameCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.ClientSkybusStats} returns this
 */
proto.flight_connect.ClientSkybusStats.prototype.setVideoFrameCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


goog.object.extend(exports, proto.flight_connect);
